// src/views/ThreeDayView.js
import { add, startOfDay } from "date-fns";

export const ThreeDayView = {
  range: (date) => {
    const start = startOfDay(date);
    return Array.from({ length: 3 }, (_, i) => add(start, { days: i }));
  },
  title: (date, { localizer }) => {
    const start = localizer.format(date, "d MMM");
    const end = localizer.format(add(date, { days: 2 }), "d MMM");
    return `${start} – ${end}`;
  },
};
